/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["cta"] }] */

(function iife(w, d) {
    const ctas = d.querySelectorAll('.CallToAction');
    ctas.forEach((cta) => {
        const ctatext = cta.querySelector('.CallToAction__text');
        if (!ctatext) {
            const text = cta.innerHTML;
            const span = d.createElement('span');
            span.classList.add('CallToAction__text');
            span.innerHTML = text;
            cta.innerHTML = '';
            cta.appendChild(span);
        }
    });
}(typeof global !== 'undefined' ? global : this, document));
